<div *ngIf="!show.glDrilldown" class="column-gap-1p25">
  <div
    *ngIf="bulkAccountDeleteObject?.isActive"
    class="width-100pcnt bg-main-8 height-2p5 white-12 font-4"
  >
    <div class="space-between-horizontal-align padding-0p5">
      <div class="start-row-container row-gap-0p25">
        <app-all-icons [iconNameAndStyling]="'info-filled.svg'"></app-all-icons>
        <span> {{ bulkAccountDeleteObject.infoText }} </span>
      </div>
      <div class="start-row-container row-gap-0p25">
        <app-button
          data-qa="gl-bulk-delete-cancel-button"
          [type]="'white-green'"
          [size]="'xsmall'"
          (buttonClick)="closeBulkDelete(false)"
        >
          Cancel
        </app-button>
        <app-button
          *ngIf="bulkAccountDeleteObject.selectedAccounts.length"
          data-qa="gl-bulk-delete-confirm-button"
          [type]="'red-white'"
          [size]="'xsmall'"
          (buttonClick)="closeBulkDelete(true)"
        >
          Delete {{ bulkAccountDeleteObject.selectedAccounts.length }}
          {{ bulkAccountDeleteObject.selectedAccounts.length === 1 ? 'account' : 'accounts' }}
        </app-button>
      </div>
    </div>
  </div>
  <div class="width-32" [ngClass]="'padding-bttm-1'">
    <app-input
      [input]="searchValue"
      [prefixFirstIcon]="'search.svg'"
      [placeholder]="'Search by account name, account # or journal entry #'"
      [suffixSecondIcon]="searchValue?.length ? 'close.svg' : ''"
      (suffixSecondIconEmitter)="clearFilter()"
      (inputChange)="filterAccountsByNameOrCode($event)">
    </app-input>
  </div>
<div *ngIf="zeroBalanceAccHelper.areAccountsWithZeroBalanceHidden"
  class="bg-main-8 white-12 space-between-horizontal padding-0-0p46875 height-2p185 align-items-center caption-2 bold500">
  <div class="start-row-container row-gap-0p5">
    <app-all-icons [iconNameAndStyling]="'info-filled.svg'"></app-all-icons>
    {{zeroBalanceAccHelper.countOfFilteredAccountWithZeroBalance}} {{zeroBalanceAccHelper.textForAccounts}} with zero balance filtered out
  </div>
  <div>
    <app-button
    [type]="'white-green'"
    [size]="'xsmall'"
    (buttonClick)="showAccountsWithZeroBalance()">
    Cancel
    </app-button>
  </div>
</div>
<div class="table-fms">
  <table #accountTable>
    <thead>
      <tr>
        <th *ngIf="bulkAccountDeleteObject?.isActive" class="size-xxs">
        <app-checkbox
            data-qa="tb-bulk-delete-checkbox-all"
            [checked]="bulkAccountDeleteObject.bulkDeleteAllCheckbox.selected"
            [minus]="bulkAccountDeleteObject.bulkDeleteAllCheckbox.minus && !bulkAccountDeleteObject.bulkDeleteAllCheckbox.selected"
            (checkBoxClicked)="toggleBulkDeleteAll($event)"
          >
        </app-checkbox>
        </th>
        <th class="size-xxs">
          <app-three-dots-menu
            data-qa="tb-three-dot-menu"
            [matMenuTriggerFor]="tbThreeDotMenu"
          >
          </app-three-dots-menu>
          <mat-menu #tbThreeDotMenu="matMenu">
            <ul class="list">
              <app-drop-down-item
              data-qa="tb-balance-change"
              class="width-100pcnt"
              [text]="zeroBalanceAccHelper.areAccountsWithZeroBalanceHidden ? zeroBalanceAccHelper.show : zeroBalanceAccHelper.hide"
              [iconNameAndStyling]="(zeroBalanceAccHelper.areAccountsWithZeroBalanceHidden ? 'eye.svg' : 'crossed-eye.svg') + '; icon-size-1p25'"
              (click)="showOrHideAccountsWithZeroBalance()">
            </app-drop-down-item>
              <app-drop-down-item
                data-qa="tb-excel-export"
                class="width-100pcnt"
                [text]="'Export'"
                [iconNameAndStyling]="'excel.svg; icon-size-1p25'"
                (click)="exportExcel()"
              >
              </app-drop-down-item>
              <app-drop-down-item
                *ngIf="manualAccounts.length && !isLocked"
                data-qa="tb-bulk-delete-mode-on"
                class="width-100pcnt"
                [menuItemClass]="'red-10'"
                [text]="'Bulk delete'"
                [iconNameAndStyling]="'delete.svg; icon-size-1p25'"
                (click)="initBulkDeleteMode()"
              >
              </app-drop-down-item>
            </ul>
          </mat-menu>
        </th>
        <th class="size-xs" [attr.colspan]="isDrilldown ? 2 : 1" appSort
            [arr]="[manualAccounts, tbData]"
            [keySelector]="accountSorting.byAccountCode"
            [isActivated]="true"
            [order]="'asc'">
          Account
        </th>
        <th *ngIf="!isDrilldown" class="width-17p1875">Items</th>
        <th class="width-12p8125" appSort
            [arr]="[manualAccounts, tbData]"
            [keySelector]="accountSorting.byOriginalBalance">
          Original Balance
        </th>
        <th class="width-12p8125 box" appSort
            [arr]="[manualAccounts, tbData]"
            [keySelector]="accountSorting.byAdjustment">
          Adjustments
        </th>
        <th class="width-12p8125" appSort
            [arr]="[manualAccounts, tbData]"
            [keySelector]="accountSorting.byAdjustedTotal">
          Adjusted Balance
        </th>
        <th class="width-12p8125" colspan="3" appSort
            [arr]="[manualAccounts, tbData]"
            [keySelector]="accountSorting.byTransactionCount">
          Transactions
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngIf="manualAccounts.length"
        class="clickable"
        (click)="show.manualAccounts = !show.manualAccounts"
      >
        <td>
          <app-table-group-icon [opened]="show.manualAccounts"></app-table-group-icon>
        </td>
        <td
          class="first-level-left-sticky body-header light-bold"
          [attr.colspan]="bulkAccountDeleteObject?.isActive ? 2 : 1"
        >
          Manual accounts
        </td>
        <td colspan="2"></td>
        <td class="box"></td>
        <td colspan="4"></td>
      </tr>
      <ng-container *ngIf="show.manualAccounts">
        <tr
          *ngFor="let account of manualAccounts"
          data-qa="tb-manual-account-open-drilldown"
          class="wrapper-with-hidden-part"
        >
          <ng-container *ngIf="account.showInTb">
            <td *ngIf="bulkAccountDeleteObject?.isActive">
              <app-checkbox
                [attr.data-qa]="'tb-bulk-delete-checkbox-' + account.id"
                [checked]="account.isSelectedForDelete"
                (checkBoxClicked)="selectForBulkDelete(account, $event); setBulkDeleteAllCheckbox()"
              >
              </app-checkbox>
            </td>
            <td>
              <ng-container *ngIf="account.isManual && !isLocked">
                <app-three-dots-menu
                  data-qa="tb-manual-three-dotted"
                  [matMenuTriggerFor]="tbManualThreeDotted">
                </app-three-dots-menu>
                <mat-menu #tbManualThreeDotted="matMenu">
                  <ul class="list">
                    <app-drop-down-item
                      data-qa="tb-edit-manual-account"
                      class="width-100pcnt"
                      [text]="'Edit manual account'"
                      [iconNameAndStyling]="'edit.svg'"
                      (click)="editManualAccount(account)">
                    </app-drop-down-item>
                    <app-drop-down-item
                      data-qa="tb-delete-manual-account"
                      class="width-100pcnt"
                      [text]="'Delete manual account'"
                      [iconNameAndStyling]="'delete.svg'"
                      [menuItemClass]="'red-10'"
                      (click)="handleDeleteManualAccount(account)">
                    </app-drop-down-item>
                  </ul>
                </mat-menu>
              </ng-container>
            </td>
            <td
              class="type-text size-xxl bold500 account-name clickable"
              [attr.colspan]="isDrilldown ? 2 : 1"
              [class.underline-on-hover]="account.filteredTransactions?.length"
              (click)="openDrilldown(account)"
            >
              {{ account.code }} - {{ account.name }}
            </td>
            <td *ngIf="!isDrilldown" class="width-15">
              <div class="type-text size-xl">
                {{account.financialStatementItems[0]?.partName | titlecase}} - {{ account.financialStatementItems[0]?.name | titlecase }} /
                {{account.financialStatementItems[1]?.partName | titlecase}} - {{ account.financialStatementItems[1]?.name | titlecase }}
              </div>
            </td>
            <td>
            <span class="min-width-4 start-row-container">
              {{ account.sums.sumITP | numberswitcher: switcher:0 | negativeValueToBraces | dashInsteadOfNull }}
            </span>
            </td>
            <td class="box">
              <span class="min-width-4 start-row-container">
                {{ account.sums.manualDebit - account.sums.manualCredit | numberswitcher: switcher:0 | negativeValueToBraces | dashInsteadOfNull }}
              </span>
            </td>
            <td>
            <span class="min-width-4 start-row-container">
              {{ account.sums.balance | numberswitcher: switcher:0 | negativeValueToBraces | dashInsteadOfNull }}
            </span>
            </td>
            <td class="size-xxs"></td>
            <td
              class="clickable"
              [class.underline-on-hover]="account.filteredTransactions?.length"
              (click)="openDrilldown(account)"
            >
              <div>
                <div *ngIf="account.filteredTransactions?.length" class="height-1p875 width-11">
                  <div class="start-row-container height-1p875 width-11">
                  <span class="main-8">
                    <span>
                      <span class="hidden-part"> View </span>
                      <span> {{ account.filteredTransactions.length | numberswitcher:switcher:0 }} </span>
                      <span class="hidden-part"> {{ account.filteredTransactions.length === 1 ? 'entry' : 'entries' }} </span>
                    </span>
                  </span>
                  </div>
                </div>
                <div *ngIf="!account.filteredTransactions?.length" class="height-1p875 width-11 main-8 start-row-container">
                <span class="hidden-on-hover-part">
                  {{ account.filteredTransactions?.length | numberswitcher:switcher:0 }}
                </span>
                  <span class="hidden-part">
                  No entries to view
                </span>
                </div>
              </div>
            </td>
            <td class="size-xxs" (click)="openDrilldown(account)">
              <app-all-icons *ngIf="account.filteredTransactions?.length" class="main-8 width-1p09375 height-1p09375 hidden-part" [iconNameAndStyling]="'right-arrow.svg'"></app-all-icons>
            </td>
          </ng-container>
        </tr>
      </ng-container>
      <tr *ngIf="tbData.length && manualAccounts.length" class="clickable" (click)="show.existingAccounts = !show.existingAccounts">
        <td>
          <app-table-group-icon [opened]="(show.existingAccounts)"></app-table-group-icon>
        </td>
        <td class="first-level-left-sticky body-header light-bold" [attr.colspan]="bulkAccountDeleteObject?.isActive ? 4 : 3">
          Existing accounts
        </td>
        <td class="box"></td>
        <td colspan="4"></td>
      </tr>
      <ng-container *ngIf="show.existingAccounts">
        <tr
          *ngFor="let account of tbData"
          class="wrapper-with-hidden-part"
          data-qa="tb-existing-account-open-drilldown"
        >
          <ng-container *ngIf="account.showInTb">
            <td [attr.colspan]="bulkAccountDeleteObject?.isActive ? 2 : 1"></td>
            <td
              class="type-text size-xxl bold500 account-name clickable"
              [class.underline-on-hover]="account.filteredTransactions?.length"
              [attr.colspan]="isDrilldown ? 2 : 1"
              (click)="openDrilldown(account)"
            >
              {{ account.code }} - {{ account.name }}
            </td>
            <td *ngIf="!isDrilldown" class="width-15">
              <div class="type-text size-xl">
                {{account.financialStatementItems[0]?.partName | titlecase}} - {{ account.financialStatementItems[0]?.name | titlecase }} /
                {{account.financialStatementItems[1]?.partName | titlecase}} - {{ account.financialStatementItems[1]?.name | titlecase }}
              </div>
            </td>
            <td>
              <span class="start-row-container">
                {{ account.sums.sumITP | numberswitcher: switcher:0 | negativeValueToBraces | dashInsteadOfNull }}
              </span>
            </td>
            <td class="box">
                <span class="start-row-container">
                  {{ account.sums.manualDebit-account.sums.manualCredit | numberswitcher: switcher:0 | negativeValueToBraces | dashInsteadOfNull }}
                </span>
            </td>
            <td>
              <span class="start-row-container">
                {{ account.sums.balance | numberswitcher: switcher:0 | negativeValueToBraces | dashInsteadOfNull }}
              </span>
            </td>
            <td class="size-xxs"></td>
            <td
              class="clickable"
              [class.underline-on-hover]="account.filteredTransactions?.length"
              (click)="openDrilldown(account)"
            >
              <div>
                <div *ngIf="account?.filteredTransactions?.length" class="height-1p875 width-11">
                  <div class="start-row-container height-1p875 width-11">
                  <span class="main-8 centered-row-container">
                    <span>
                      <span class="hidden-part"> View </span>
                      <span> {{ account.filteredTransactions.length | numberswitcher:switcher:0 }} </span>
                      <span class="hidden-part"> {{ account.filteredTransactions.length === 1 ? 'entry' : 'entries' }} </span>
                    </span>
                  </span>
                  </div>
                </div>
                <div *ngIf="!account.filteredTransactions.length" class="height-1p875 width-11 main-8 start-row-container">
                <span class="hidden-on-hover-part">
                  {{ account.filteredTransactions.length | numberswitcher:switcher:0 }}
                </span>
                  <span class="hidden-part">
                  No entries to view
                </span>
                </div>
              </div>
            </td>
            <td class="size-xxs" (click)="openDrilldown(account)">
              <app-all-icons *ngIf="account.filteredTransactions.length" class="main-8 width-1p09375 height-1p09375 hidden-part" [iconNameAndStyling]="'right-arrow.svg'"></app-all-icons>
            </td>
          </ng-container>
          </tr>
      </ng-container>
    </tbody>
    <tfoot>
      <tr class="grand-total first-level-bottom-sticky">
        <td [attr.colspan]="bulkAccountDeleteObject?.isActive ? 4 : 3">Accounts total</td>
        <td>
          <span class="min-width-4 start-row-container">{{ totals.totalBeforeChanges | numberswitcher: switcher:0 | negativeValueToBraces | dashInsteadOfNull }}</span>
        </td>
        <td>
          <span class="min-width-4 start-row-container">{{ totals.totalAdjustments | numberswitcher: switcher:0 | negativeValueToBraces | dashInsteadOfNull }}</span>
        </td>
        <td>
          <span class="min-width-4 start-row-container">{{ totals.totalAfterChanges | numberswitcher: switcher:0 | negativeValueToBraces | dashInsteadOfNull }}</span>
        </td>
        <td colspan="3"></td>
      </tr>
    </tfoot>
  </table>
</div>
</div>

<ng-container *ngIf="show.glDrilldown">
  <div *ngIf="showTrialBalanceNavBar" class="bg-main-8 white-12 padding-1 start-row-container row-gap-0p5">
    <span
      class="clickable navigation-link start-row-container row-gap-0p5"
      (click)="show.glDrilldown = !show.glDrilldown"
      data-qa="tb-return-from-gl-button"
    >
      <span> Accounts summary </span>
      <app-all-icons
        [iconNameAndStyling]="'right-arrow.svg'">
      </app-all-icons>
    </span>
    <span *ngVar="selectedAccountForDrilldown.glTransactions.length as transactionsAmount">
        {{ selectedAccountForDrilldown.code }} -
        {{ selectedAccountForDrilldown.name }} |
        {{ transactionsAmount }} {{ transactionsAmount === 1 ? 'entry' : 'entries' }}
    </span>
  </div>

  <app-gl-table
    [quarterlyTransactionsMap]="selectedAccountForDrilldown.quarterlyTransactionsMap"
    [selectedAccountForDrilldown]="selectedAccountForDrilldown"
    [accountFilterDataObject]="accountFilterDataObject"
    >
  </app-gl-table>
</ng-container>

<app-modal-dialog
  *ngIf="thinkTwiceModalController.isShown"
  [header]="thinkTwiceModalController.text.title"
  [addAdditionalText]="true"
  [mainText]="[thinkTwiceModalController.text.description]"
  (isConfirmed)="deleteManualAccount($event)">
</app-modal-dialog>
